module.exports = __webpack_public_path__ + "static/bilxtra-f9c53849447123e1470a5267a2cf3e2e.png";